import React from 'react'
import moment from 'moment'
import Dropzone from 'react-dropzone'
import DropzonePreview from '../forms/dropzone-preview'
import cx from 'classnames'
import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock,
} from '../modal-form/modal-form'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

const onChange = (fields, index, type, newValue) => {
  const newFields = [...fields.value];
  const originalElement = newFields.find(elm => elm.id === index)

  newFields.splice(
    newFields.findIndex(elm => elm.id === index),
    1,
    {
      ...originalElement,
      [type]: newValue
    }
  );

  fields.onChange(newFields);
}

const ImageBlock = ({ title, image, fields, index, type }) => {
  const displayTime = image && (image.display_taken_at || image.displayTakenAt || image.createdAt)
  const isFallback = image && (image.is_fallback || image.isFallback)

  return (
    <ModalFormBlock customClassName="vertical" style={{ width: '50%', flex: '1 1 50%', minWidth: 0 }}>
      <label>
        {title}
        {image && image.preview && (
          <a href={image.preview} target='_blank'>
            <img style={{ marginLeft: '5px' }} height="12px" src={require('../../images/export-icon.svg')} alt="view" />
          </a>
        )}
      </label>
      <Dropzone
        className='dropzone'
        activeClassName='active'
        multiple={false}
        style={{ width: '100%', boxSizing: 'border-box' }}
        onDrop={(files) => onChange(fields, index, type, files[0])}
      >
        <DropzonePreview attribute={{
          value: image && image.preview ? { preview: image.preview, name: '' } : null,
          onChange: (val) => onChange(fields, index, type, val)
        }} />
      </Dropzone>

      {/* Render Taken At Timestamp */}
      {displayTime && (
        <div style={{ marginTop: '6px', fontSize: '0.85em', textAlign: 'center' }}>
          <p className="timestamp" style={{ margin: 0 }}>
            <strong>Taken at:</strong> {moment(displayTime).format('MMMM D, YYYY [at] h:mm A')}
          </p>
          {isFallback && (
            <span style={{ color: '#d9534f', fontSize: '0.8em', display: 'block', marginTop: '2px', fontWeight: 'bold' }}>
              ⚠️ Photo taken time not found in metadata. Fallback to uploaded time used.
            </span>
          )}
        </div>
      )}
    </ModalFormBlock>
  )
}

export default ({
  fields: {
    beforeAftersAttributes
  },
  loading,
  error,
  submitting,
  handleSubmit,
  handleClose,
  modalTitle,
  submitButtonText
}) => (
  <BaseModal
    onClose={handleClose}
    title={modalTitle}
    constraints={constraints}
    contentClassName='issue-create-container'
  >
    {loading ? (
      <p>Loading...</p>
    ) : (
      <ModalForm onSubmit={handleSubmit} customClassName='issue-edit-form'>
        <ModalFormRow>
          <ModalFormBlock>
            <p className={cx({ 'centered': true, 'error': true, hidden: !error || handleSubmit })}>
              {error && error.detail}
            </p>
          </ModalFormBlock>
        </ModalFormRow>

       {beforeAftersAttributes.value.map((ba, i) => {
          const elapsed = ba.time_taken_between || ba.timeTakenBetween
          const hasBefore = ba.beforeImage && ba.beforeImage.preview
          const hasAfter = ba.afterImage && ba.afterImage.preview
          return (
            <div
              key={ba.id || `new-${i}`}
              style={{
                width: '100%',
                boxSizing: 'border-box',
                marginBottom: '16px',
                borderBottom: '1px solid #eee',
                paddingBottom: '12px'
              }}
            >
              <ModalFormRow>
                <ImageBlock title="Before Image" image={ba.beforeImage} fields={beforeAftersAttributes} index={ba.id} type="beforeImage" />
                <ImageBlock title="After Image" image={ba.afterImage} fields={beforeAftersAttributes} index={ba.id} type="afterImage" />
              </ModalFormRow>
              {/* Time Taken Banner */}
              {hasBefore && hasAfter && (
                <div
                  style={{
                    textAlign: 'center',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    padding: '6px',
                    borderRadius: '4px',
                    marginTop: '6px',
                    fontSize: '0.85em'
                  }}
                >
                  <strong>⏱️ Time Taken (Before → After):</strong> {elapsed || 'N/A'}
                </div>
              )}
            </div>
          )
        })}

        <ModalFormRow>
          <ModalFormBlock submitButton>
            <button disabled={submitting} type='submit'>
              {submitting ? 'Submitting...' : submitButtonText}
            </button>
          </ModalFormBlock>
        </ModalFormRow>
      </ModalForm>
    )}
  </BaseModal>
)


// WEBPACK FOOTER //
// ./src/components/servicings/servicing-images-form.js